<div class="section-gap">
    <div class="submit-title submit-title-typography">Applications</div>
    <div *ngIf="!loadingComplete" class="spinner-div">
      <mat-spinner class="spinner-cls"></mat-spinner>
    </div>
    <mat-tab-group animationDuration="0ms" (selectedTabChange)="selectAppTypeChange($event)" class="apps-tab-class">
      <mat-tab *ngFor="let appType of appTypes">
        <ng-template mat-tab-label>
          <span class="section-tab-title">{{appType}}</span>
        </ng-template>
        <ng-template matTabContent>
          <div *ngIf="totalItems > 0">
          <ng-container *ngIf="!isMobileDeviceSize;else mobileView">
            <div class="applications-table-container">
              <table class="applications-table" matSort (matSortChange)="sortChangeUpdate($event)">
                <caption>
                  <mat-paginator
                      [length]="totalItems"
                      [pageSize]="pageSize"
                      [pageSizeOptions]="[5, 10, 20]"
                      showFirstLastButtons
                      (page)="onPageChange($event)">
                  </mat-paginator>
                </caption>
                <thead>
                  <tr class="apps-table-header-layout apps-table-header-style">
                    <th class="flex_5" mat-sort-header="form" sortActionDescription="Sort by Form Type"><span>Form</span></th> 
                    <th class="app-table-names-col" mat-sort-header="applicantFirstName" sortActionDescription="Sort by Applicant"><span>Applicant</span></th>
                    <th class="app-table-suggested-col" mat-sort-header="firstSuggestedName" sortActionDescription="Sort by Suggested Name"><span>Suggested Name</span></th>
                    <th class="flex_8" mat-sort-header="submittedDate" sortActionDescription="Sort by Date"><span>Date</span></th>
                    <th class="app-table-negotiator-col" mat-sort-header="negotiator" sortActionDescription="Sort by Negotiator"><span>Negotiator</span></th>
                    <th *ngIf="appType.includes('Approved')" class="app-table-status-col" mat-sort-header="status" sortActionDescription="Sort by Status"><span>Status</span></th>
                    <th class="app-table-progress-col"><span>Progress</span></th>
                    <th class="flex_5 center-aligned"><span>View</span></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let app of paginatedAppl" class="apps-table-value-layout apps-table-value-style">
                    <td class="flex_5 left-aligned">
                      <span class="form-name-outer"><span style="padding-left: 15px;">{{ app.form }}</span></span>
                    </td>
                    <td class="app-table-names-col app-table-data-col">
                      {{ app.applicantFirstName }} {{ app.applicantLastName }}
                    </td>
                    <td class="app-table-suggested-col app-table-data-col">
                      {{ app.firstSuggestedName }}
                    </td>
                    <td class="flex_8 app-table-data-col">
                      {{ app.submittedDate }}
                    </td>
                    <td class="app-table-negotiator-col app-table-data-col">
                      {{ app.negotiator }}
                    </td>
                    <td *ngIf="appType.includes('Approved')" class="app-table-status-col app-table-data-col">
                      {{ app.status }}
                    </td>
                    <td class="app-table-progress-col center-aligned">
                      <span class="app-table-progress-container">
                        <mat-progress-spinner mode="determinate" [value]="100" [diameter]="24" [strokeWidth]="4" class="app-icon app-progress-icon app-status-spinner-base"></mat-progress-spinner>
                        <mat-progress-spinner mode="determinate" [value]="app.progressValue" [diameter]="24" [strokeWidth]="4" class="app-icon app-progress-icon app-status-spinner-progress"></mat-progress-spinner>
                      </span>
                    </td>
                    <td class="app-table-columns flex_5 center-aligned">
                      <button mat-icon-button aria-label="View icon" class="app-icon-background" (click)="viewDetails(app)">
                        <mat-icon class="app-icon">visibility</mat-icon>
                      </button>
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>
          
          <ng-template #mobileView>
            <div class="applications-mobile">
              <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]"
                [showFirstLastButtons]="false" (page)="onPageChange($event)">
              </mat-paginator>
              <ng-container *ngFor="let app of paginatedAppl">
                <div class="app-mobile">
                  <div class="app-mobile-style">
                    <div class="app-mobile-info">
                      <div class="app-mobile-details-text">{{ app.formTypeDesc }}</div>
                      <div class="app-mobile-form-text">{{ app.firstSuggestedName }}</div>
                      <div *ngIf="appType.includes('Approved')" class="app-mobile-form-text">{{ app.status }}</div> 
                    </div>
                    <div class="float-right">
                      <span class="app-mobile-progress-container">
                        <mat-progress-spinner mode="determinate" [value]="100" [diameter]="24" [strokeWidth]="4"
                          class="app-mobile-icon app-progress-icon app-status-spinner-base "></mat-progress-spinner>
                        <mat-progress-spinner mode="determinate" [value]="app.progressValue" [diameter]="24" [strokeWidth]="4"
                          class="app-mobile-icon app-progress-icon app-status-spinner-progress"></mat-progress-spinner>
                      </span>
                      <div class="card-icon-cls">
                        <button class="card-icon-cls menu-background" mat-icon-button [matMenuTriggerFor]="applicationMenu"
                          aria-label="More details button with a menu" [matMenuTriggerData]="{'element': app}">
                          <mat-icon class="details-cls">more_vert</mat-icon>
                        </button>
                      </div>
          
                      <mat-menu #applicationMenu="matMenu" class="menu-containr" [hasBackdrop]="true">
                        <button mat-menu-item (click)="viewDetails(app)">
                          <mat-icon>visibility</mat-icon>
                          <span>View Application</span>
                        </button>
                      </mat-menu>
          
                    </div>
                  </div>
                  <div class="app-mobile-style-flex padding-top-0">
                    <div class="card-section-bottom-item">
                      <label class="card-bottom-item-title">Applicant</label>
                      <label class="card-bottom-item-value">{{ app.applicantFirstName?.[0] }}. {{ app.applicantLastName }}</label>
                    </div>
                    <div class="card-section-bottom-item padding-left-10">
                      <label class="card-bottom-item-title">Negotiator</label>
                      <label class="card-bottom-item-value">{{app.negotiatorShort}}</label>
                    </div>
                    <div class="card-section-bottom-last-item">
                      <label class="card-bottom-item-title">Modified Date</label>
                      <label class="card-bottom-item-value">{{ app.submittedDate }}</label>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-template>
          </div>
          <div *ngIf="totalItems === 0">
            <br><br>No Applications found.
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>